var React = require("react");
const createReactClass = require("create-react-class");

var form = require('../../deploynaut/js/Form.jsx');

var UploadCertificateForm = createReactClass({

	render: function() {
		return (
			<div className="certificate-form">
				<p>
					Paste the contents of your certificate and private key* into the fields below. We'll try to
					resolve any intermediate certificates automatically for you, or you can paste them after your
					certificate if required.
				</p>
				<p>
					*RSA key length is currently limited to 2048 bits.
				</p>
				<form.Form
					ref="uploadCertificateForm"
					url={this.props.actionURL}
					securityID={this.props.model.SecurityID}
					buttonTitle="Replace certificate"
					buttonSubmittingTitle="Uploading"
					afterSuccess={this.props.afterSuccess}
					cancelButton={<button className="btn btn-link" onClick={this.props.cancelHandler}>Cancel</button>}
				>
					<div className="row">
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor="crt">SSL certificate</label>
								<form.Textarea
									name="crt"
									required
									validationError="Please set a valid certificate"
									rows="6"
									placeholder="-----BEGIN CERTIFICATE-----
MIID0DCCArigAwIBAgIBATANBgkqhkUFADB..."
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group">
								<label htmlFor="key">Private key</label>
								<form.Textarea
									name="key"
									required
									validationError="Please set a valid private key"
									rows="6"
									placeholder="-----BEGIN RSA PRIVATE KEY-----
MIICXAIBAAKBgQCqGKukO1De7zhZj6+H0q..."
								/>
							</div>
						</div>
					</div>

					<p>
						Consult our <a href={this.props.model.DocumentationLink} target="_blank">SSL documentation</a> if you need further assistance.
					</p>
				</form.Form>
			</div>
		);
	}
});

module.exports = UploadCertificateForm;
